import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Image as CloudinaryImage, Transformation } from "cloudinary-react";
import Image from "../../components/Image/Image.jsx";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";

class VotingTicketModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: "",
      wantToVote: false
    };
  }

  componentDidMount() {
    this.props.getUser();
  }

  giveVote = ticketType => {
    let { data } = this.props;
    data.ticketType = ticketType;
    this.setState({ wantToVote: false });
    this.props.showAppLoader();
    this.props.giveVote(data);
    this.props.modalClose();
  };

  modalClose = () => {
    this.setState({ wantToVote: false });
    this.props.modalClose();
  };

  render() {
    let { userData, data } = this.props;
    let { isVotedByMe } = data;
    let { wantToVote } = this.state;
    this.props.open && this.props.userData._id == ""
      ? this.props.getUser()
      : null;
    let totalVote =
      userData.tickets.regular +
      userData.tickets.gold +
      userData.tickets.platinum;
    return (
      <div
        className="modal"
        id="ticketmodal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={this.props.open ? { display: "block" } : {}}
        onClick={this.modalClose}
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          {isVotedByMe && !wantToVote ? (
            <div
              className="modal-content animated bounceIn"
              onClick={e => e.stopPropagation()}
            >
              <div className="ticket-modal">
                <div className="modal-header">
                  {userData.profilePic != "" ? (
                    <CloudinaryImage
                      cloudName="contestee"
                      publicId={data.profilePic}
                      crop="scale"
                      width="250"
                      className="rounded-circle"
                    />
                  ) : null}
                  <div>
                    <span className="cotmed">{totalVote}</span>
                    <p>Available Voting Tickets</p>
                  </div>
                </div>
                <React.Fragment>
                  <div className="ticketcontent pt-4">
                    <div className="f-modal-alert">
                      <div className="f-modal-icon f-modal-warning animate">
                        <span className="f-modal-body pulseWarningIns"></span>
                        <span className="f-modal-dot pulseWarningIns"></span>
                        <div className="f-modal-placeholder"></div>
                        <div className="f-modal-fix"></div>
                      </div>
                    </div>
                    <p className="f-14">
                      You have already voted to this contestants today. Are you
                      sure, you want to vote again?
                    </p>
                  </div>
                </React.Fragment>
                <div className="modalfooter dualbtn">
                  <button
                    className="col-secondary"
                    onClick={() => this.setState({ wantToVote: true })}
                  >
                    Yes
                  </button>
                  <button className="col-secondary" onClick={this.modalClose}>
                    No
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="modal-content animated bounceIn"
              onClick={e => e.stopPropagation()}
            >
              <div className="ticket-modal">
                <div className="modal-header">
                  {userData.profilePic != "" ? (
                    <CloudinaryImage
                      cloudName="contestee"
                      publicId={data.profilePic}
                      crop="scale"
                      width="250"
                      className="rounded-circle"
                    />
                  ) : null}
                  <div>
                    <span className="cotmed">{totalVote}</span>
                    <p>Available Voting Tickets</p>
                  </div>
                </div>
                {totalVote == 0 ? (
                  <React.Fragment>
                    <div className="ticketcontent pt-4">
                      <div className="f-modal-alert">
                        <div className="f-modal-icon f-modal-warning animate">
                          <span className="f-modal-body pulseWarningIns"></span>
                          <span className="f-modal-dot pulseWarningIns"></span>
                          <div className="f-modal-placeholder"></div>
                          <div className="f-modal-fix"></div>
                        </div>
                      </div>
                      <p className="mb-3 cotmed">Out of Voting Ticket</p>
                      <p className="f-14">
                        In order to earn new voting tickets you have 2 options:
                        Wait till next day or select one of the following
                        options.
                      </p>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="ticketcontent">
                      <p className="mb-0 cotmed">Tap on button to vote</p>
                    </div>
                    <div className="modalmaincontent">
                      <div className="ticketenroll">
                        <button
                          className="btn btn-secondary"
                          disabled={userData.tickets.regular == 0}
                          onClick={() => {
                            this.giveVote("regular");
                          }}
                        >
                          Regular
                        </button>
                        <div>
                          <button id="PopoverRegular" type="button">
                            <i className="fas fa-question-circle"></i>
                          </button>
                          <UncontrolledPopover
                            trigger="focus"
                            placement="left"
                            target="PopoverRegular"
                          >
                            <PopoverHeader>Regular Ticket</PopoverHeader>
                            <PopoverBody>
                              The value of this ticket is{" "}
                              <strong>1 vote</strong>.
                            </PopoverBody>
                          </UncontrolledPopover>
                        </div>
                      </div>
                      <div className="ticketenroll">
                        <button
                          className="btn btn-yellow"
                          disabled={userData.tickets.gold == 0}
                          onClick={() => {
                            this.giveVote("gold");
                          }}
                        >
                          Gold
                        </button>
                        <div>
                          <button id="PopoverGold" type="button">
                            <i className="fas fa-question-circle"></i>
                          </button>
                          <UncontrolledPopover
                            trigger="focus"
                            placement="left"
                            target="PopoverGold"
                          >
                            <PopoverHeader>Gold Ticket</PopoverHeader>
                            <PopoverBody>
                              The value of this ticket is{" "}
                              <strong>3 votes</strong>. that you can Purchase.
                            </PopoverBody>
                          </UncontrolledPopover>
                        </div>
                      </div>
                      <div className="ticketenroll">
                        <button
                          className="btn btn-gray"
                          disabled={userData.tickets.platinum == 0}
                          onClick={() => {
                            this.giveVote("platinum");
                          }}
                        >
                          Platinum
                        </button>
                        <div>
                          <button id="PopoverPlatinum" type="button">
                            <i className="fas fa-question-circle"></i>
                          </button>
                          <UncontrolledPopover
                            trigger="focus"
                            placement="left"
                            target="PopoverPlatinum"
                          >
                            <PopoverHeader>Platinum Ticket</PopoverHeader>
                            <PopoverBody>
                              The value of this ticket is{" "}
                              <strong>5 votes</strong>. That You can earn by
                              becoming a Platinum User.
                            </PopoverBody>
                          </UncontrolledPopover>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {totalVote === 0 ? (
                  <div className="modalfooter">
                    <a href="#" className="col-secondary">
                      Watch Ads
                    </a>
                    <a href="#" className="col-secondary">
                      Purchases
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ votingTicketModal, user }) => {
  const { open, data } = votingTicketModal;
  const { userData } = user;
  return { open, userData, data };
};

const mapDispatchToProps = dispatch => ({
  modalClose: () => dispatch(actions.votingTicketModalClose()),
  getUser: () => dispatch(actions.getUser()),
  giveVote: payload => dispatch(actions.giveVote(payload)),
  showAppLoader: () => dispatch(actions.showAppLoader())
});

export default connect(mapStateToProps, mapDispatchToProps)(VotingTicketModal);
